import React, { Component } from 'react';
import axios from "axios";
import VForm from 'react-validation/build/form';
import VInput from 'react-validation/build/input';
import VButton from 'react-validation/build/button';
import validator from 'validator';
import Waiting from '../../../waiting';
import { appConfig } from '../../../../tools/AppConfig';
import SpotiiLogo from "./../../../../../statics/img/spotii/spotii.png";
import paymobLogo from "./../../../../../statics/img/esaypaisa/paymob.png";
import SpotiiStatus from './SpotiiStatus';
import Countdown360 from 'react-countdown360';
import './Spotii.css';

const required = (value) => {
    if (!value.toString().trim().length) {
      // We can return string or jsx as the 'error' prop for the validated Component
      return <div className="alert alert-danger fieldErrorMessage" role="alert"> This field is required.</div>;
    }
};
const phoneV = (value) => {
    if(!validator.isNumeric(value) || value.length > 11){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"> Please enter a valid phone number.</div>;
    }
};
const emailV = (value) => {
    if(!validator.isEmail(value)){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"> Please enter a valid Email.</div>;
    }
};

class Spotii extends Component {

    constructor(props) {
        super(props)
        this.state = {
            step: 1,
            phone: "",
            email: "",
            iframe_url: "",
            user_data: "",
            trnx_id: "",
            count_down: true,
            spotii_status: "",
            status_message: "",
            redirection_url: "",
            re_inquire_times: 0,
            //public
            waiting: false,
            error: false,
            error_message: "",
        }
    }
    componentDidMount() {
        //  handle current step
        let transaction_id = null;
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        transaction_id = urlParams.get('trx_id')
        if(transaction_id != null){
            this.setState({trnx_id: transaction_id}, () => {
                this.handleInquiryRequest()
            })
        }
    }

    // pay request
    handlePayRequest = (e) =>{
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "source": {
                    "mobile_number": "+971" + this.state.phone,
                    "identifier": this.state.email,
                    "subtype": "SPOTII",
                },
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({error: false, error_message: "", trnx_id: resp.data.id}, () => {
                    window.location.href = resp.data.data.checkout_url;
                });
            })
            .catch((err)=>{
                if(err.response){
                    if(err.response.status == 401){
                        this.setState({waiting: false, error: true, error_message: err.response.data.detail});
                    }else{
                        if(err.response.data.message){
                            this.setState({waiting: false, error: true, error_message: err.response.data.message});
                        }else{
                            this.setState({waiting: false, error: true, error_message: "Something went wrong. please try again later."});
                        }
                    }  
                }else{
                    this.setState({waiting: false, error: true, error_message: "Something went wrong. please try again later."});
                }
            });
        });
        e.preventDefault();
    }
    // inquiry request
    handleInquiryRequest = () =>{
        this.setState({step: 2, waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + "/api/acceptance/transactions/transaction_inquiry";
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "transaction_id": this.state.trnx_id,
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                // success
                if(resp.data.success == "true" && resp.data.pending == "false"){
                    this.setState({waiting: false, step: 3, spotii_status: "success", status_message: resp.data["data.message"], redirection_url: resp.data.redirection_url});
                // pending
                }else if(resp.data.success == "false" && resp.data.pending == "true"){
                    // Max Reinquire Times (3)
                    // this.setState({re_inquire_times: this.state.re_inquire_times + 1});
                    // if(this.state.re_inquire_times == 3){
                        this.setState({waiting: false, step: 3, spotii_status: "pending", status_message: resp.data["data.message"], redirection_url: resp.data.redirection_url});
                    // }else{
                    //     this.setState({waiting: false, count_down: true});
                    // }
                // fail
                }else if(resp.data.success == "false" && resp.data.pending == "false"){
                    this.setState({waiting: false, step: 3, spotii_status: "fail", status_message: resp.data["data.message"], redirection_url: resp.data.redirection_url});
                }
            })
            .catch((err)=>{
                if(err.response){
                    if(err.response.status == 401){
                        this.setState({waiting: false, count_down: false, error: true, error_message: err.response.data.detail});
                    }else{
                        if(err.response.data.message){
                            this.setState({ waiting: false, count_down: false, error: true, error_message: err.response.data.message});
                        }else{
                            this.setState({waiting: false, count_down: false, error: true, error_message: "Something went wrong. please try again later."});
                        }
                    }  
                }else{
                    this.setState({waiting: false, count_down: false, error: true, error_message: "Something went wrong. please try again later."});
                }
            });
        });
    }
    // handle return back
    handleReturnBack = () => {
        this.setState({step: 3, spotii_status: "fail", status_message: "Transaction abandoned."});
    }

    renderStep1 = () => (
        <div className="spotii_content">
            <VForm onSubmit={this.handlePayRequest}>
                <label>Phone number</label>
                <div className="spotii_input">
                    <span>+971</span>
                    <VInput 
                        type="text"
                        name="phone"
                        value={this.state.phone}
                        onChange={(e)=>this.setState({phone: e.target.value})}
                        validations={[required, phoneV]} 
                        placeholder= "Enter phone number."
                    />
                </div>
                <label>Email</label>
                <VInput 
                    type="text"
                    name="email"
                    value={this.state.email}
                    onChange={(e)=>this.setState({email: e.target.value})}
                    validations={[required, emailV]} 
                    placeholder= "Enter email."
                />
                <VButton>Proceed</VButton>
            </VForm>
            {this.state.error &&
                <div className="spotii_error">
                    {this.state.error_message}
                </div>
            }
        </div>
    )
    renderStep2 = () => (
        <div className="spotii_content count_down_container text-center">
            {this.state.count_down &&
                <>
                    <h3>Authorization required.</h3>
                    <p>You will be redirected to Spotii checkout page, please proceed confirming your payment within the given time.</p>
                    <Countdown360
                        seconds={45}
                        borderFillColor="#FFD5D1"
                        borderUnfillColor="#FF4D4A"
                        borderWidth="3"
                        fontSize="30"
                        fontWeight="normal"
                        clockwise
                        width="158"
                        smooth
                        onComplete={()=>this.handleInquiryRequest()}
                    />
                </>
            }
            {this.state.error &&
                <div className="spotii_error">
                    {this.state.error_message}
                </div>
            }
        </div>
    )

    render() {
        return (
            <div className="spotii_page_container">
                <div className="spotii_container">
                    {this.state.step == 1 && <span onClick={()=>this.handleReturnBack()}>X <span>Cancel</span></span>}
                    <div className="spotii_header">
                        <img src={SpotiiLogo} />
                    </div>
                    {this.state.waiting ?
                        <Waiting height='400px' />
                    :
                        this.state.step == 1 ?
                            this.renderStep1()
                        :this.state.step == 2 ?
                            this.renderStep2()
                        :
                            <SpotiiStatus 
                                spotii_status={this.state.spotii_status}
                                status_message={this.state.status_message}
                                redirection_url={this.state.redirection_url}
                            />
                            
                    }
                    <div className="spotii_footer">
                        <span>Powered by</span>
                        <img src={paymobLogo} className="paymob" alt="Paymob" />
                    </div>
                </div>
            </div>
        )
    }
}
export default Spotii;